<template>
  <component :is="process" />
</template>

<script>
import basic from './default.vue';

export default {
  name: 'profile-info',
  components: {default: basic},
  props: ['process']
}
</script>